// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1xfjw","right":"Footer_right__2iaLl","buttons":"Footer_buttons__1kSSG"};